import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { mget, mpost, errMsg, fmtTs } from "@/manager/lib";
import { Card } from "@/manager/ui";

export default function DigestCard() {
  const [p, setP] = useState(null);
  const [logs, setLogs] = useState([]);
  const [busy, setBusy] = useState(false);
  const load = () => { mget("/digest/preview").then(setP); mget("/digest/logs").then(setLogs); };
  useEffect(load, []);
  const send = async () => {
    setBusy(true);
    try { const r = await mpost("/digest/send"); r.ok ? toast.success(`Resumen enviado a ${r.to}`) : toast.error(`No se pudo enviar: ${r.error}`); load(); }
    catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <Card className="p-5" data-testid="digest-card">
      <h3 className="font-display text-lg mb-1">Resumen diario por email</h3>
      <p className="text-xs text-[#6b6a66] mb-4">Cada día a las 9:00 llega a <strong>{logs[0]?.to || "aurasantcugat@gmail.com"}</strong> con las tareas urgentes, los eventos de hoy y los próximos 3 días con camareros sin confirmar y los productos bajo el stock mínimo.</p>
      {p && (
        <div className="grid grid-cols-3 gap-3 mb-4">
          {[["Tareas urgentes", p.urgent_tasks.length, "digest-count-tasks"], ["Faltan camareros", p.missing_staff.length, "digest-count-staff"], ["A reponer", p.low_stock.length, "digest-count-stock"]].map(([l, v, t]) => (
            <div key={t} className="rounded-xl bg-[#F7F5F0] px-3 py-2"><p className="font-display text-2xl" data-testid={t}>{v}</p><p className="text-[10px] uppercase tracking-[0.14em] text-[#6b6a66]">{l}</p></div>
          ))}
        </div>
      )}
      <Button variant="outline" className="rounded-full gap-2 mb-3" disabled={busy} onClick={send} data-testid="digest-send-now"><Mail size={14} /> {busy ? "Enviando…" : "Enviar ahora"}</Button>
      {logs.slice(0, 5).map((l) => (
        <p key={l.id} className={`text-xs py-0.5 ${l.ok ? "text-[#6b6a66]" : "text-rose-700"}`} data-testid="digest-log">
          {fmtTs(l.at)} · {l.trigger === "cron" ? "automático" : "manual"} · {l.ok ? `enviado (${l.counts.urgent_tasks} tareas, ${l.counts.missing_staff} eventos, ${l.counts.low_stock} productos)` : `error: ${l.error}`}
        </p>
      ))}
    </Card>
  );
}
